import { Grid } from "@mui/material"
import { ISettingsItem } from "../../../Settings"
import { useTranslation } from "../../../i18n"

export default function ChoosePlanText({ name, variables }: ISettingsItem) {
  const { t } = useTranslation()
  const defaultTextArray = [t.page1.choosePlanTitle, t.page1.choosePlanSubtitle]
  const { text = defaultTextArray } = variables || {}

  return (
    <Grid item className={name ? `${name} choose-plan-text` : "choose-plan-text"} xs={12}>
      <div className="textArea">
        <h3>{text[0]}</h3>
        <p>{text[1]}</p>
      </div>
    </Grid>
  )
}